// import { $req } from "@/utils";
// // 获取产品列表数据
// export default {
// 	getProductList(b) {
// 		return $req.postCrm("/crm/product/getProductList", b);
// 	}
// }
import request from '../utils/request'

//请求用户信息
export default {
    getProductList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/product/getProductList`,
			data: params
		})
	},
	getProvincesList({ ...params }) {
		return request({
			method: 'GET',
			url: `/crm/dataConfig/areaList`,
			data: params
		})
	},
	getCrmInit({ ...params }){
		return request({
			method: 'GET',
			url: `/crm/init?dicType=${params.dicType}`,
			data: params
		})
	}
}